/**
 * Pack cart utilities — remove grouped pack lines (native Dawn drawer only).
 * Cart refresh is handled by cart-bridge.js for iCart + Dawn.
 */

if (!window.__packCartInit) {
  window.__packCartInit = true;

  document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pack-remove]');
  if (!button) return;

  event.preventDefault();
  const keys = (button.dataset.lineKeys || '')
    .split(',')
    .map((k) => k.trim())
    .filter(Boolean);

  if (!keys.length) return;

  button.disabled = true;

  const updates = {};
  keys.forEach((key) => {
    updates[key] = 0;
  });

  try {
    const base = window.routes?.cart_update_url || '/cart/update';
    const cartUpdateUrl = base.endsWith('.js') ? base : `${base}.js`;

    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.description || 'Could not remove pack.');
    }

    if (typeof window.refreshCartUI === 'function') {
      await window.refreshCartUI({ openDrawer: false });
    }
  } catch (error) {
    console.error(error);
    button.disabled = false;
  }
  });
}